'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00019 14.3928C10.9826 14.3928 13.4004 11.9751 13.4004 8.99262C13.4004 6.01018 10.9826 3.59243 8.00019 3.59243C5.01775 3.59243 2.6 6.01018 2.6 8.99262C2.6 11.9751 5.01775 14.3928 8.00019 14.3928ZM8.00019 15.9928C11.8663 15.9928 15.0004 12.8587 15.0004 8.99262C15.0004 5.12652 11.8663 1.99243 8.00019 1.99243C4.13409 1.99243 1 5.12652 1 8.99262C1 12.8587 4.13409 15.9928 8.00019 15.9928ZM8.00001 7.95972C8.49706 7.95972 8.90001 8.36266 8.90001 8.85972V11.8871C8.90001 12.3842 8.49706 12.7871 8.00001 12.7871C7.50295 12.7871 7.10001 12.3842 7.10001 11.8871V8.85972C7.10001 8.36266 7.50295 7.95972 8.00001 7.95972ZM7.99953 7.25214C8.54425 7.25214 8.98583 6.81056 8.98583 6.26584C8.98583 5.72112 8.54425 5.27954 7.99953 5.27954C7.45481 5.27954 7.01323 5.72112 7.01323 6.26584C7.01323 6.81056 7.45481 7.25214 7.99953 7.25214Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
